export default {
  data () {
    return {
      fields: [],
      params: {},
    }
  },
  created () {
    try {
      const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
      const fields = this.fields || []
      fields.forEach(fie => {
        const val = this.$route.query[fie] || params[fie]
        this.$set(this.params, fie, val)
      })
    } catch (error) {
      this.$toast('参数获取失败')
    }
  },
}